<p-header>
</p-header>
<p-toast id="taskedittoaster" ></p-toast>

<div class="grid">
  <div class="col-6">
    <div class="grid">
      <div class="col-12">
        <div class="grid" style="margin-bottom: 5px;">
          <div class="row">Sortimentsklammer</div>
          @if (!isMasterEditing) {
            <div class="col-10" style="padding-right: 10px;">
              <p-select id="chooseMaster" [options]="sortimentsKlammern$ | async" optionLabel="name" [(ngModel)]="selectedMaster"
                [disabled]="recipients.length > 0" (ngModelChange)="loadSortiment()" placeholder="Sortimentsklammer wählen">
              </p-select>
            </div>
          }
        </div>
        <div class="grid" style="margin-bottom: 5px;">
          <div class="row">Sortimentstyp</div>
          <div class="col-10" style="padding-right: 10px;">
            <p-select  id="chooseType" [options]="typeInfos$ | async" [showClear]="true"
              [disabled]="((typeInfos$ | async) === null || (typeInfos$ | async).length === 0) || recipients.length > 0"
              [(ngModel)]="selectedType" (ngModelChange)="activateTypeFilter()" optionLabel="name" placeholder="Typ wählen">
            </p-select>
          </div>
        </div>
        <div class="grid" style="margin-bottom: 5px;">
          <div class="row">Sortiment</div>
          <div class="col-10" style="padding-right: 10px;">
            <p-multiSelect id="chooseSortiment" [options]="sortiments$ | async"  selectedItemsLabel="{0} Sortimente ausgewählt"
              [disabled]="((sortiments$ | async) === null || (sortiments$ |async).length === 0) || recipients.length > 0" placeholder="Sortiment wählen"
              [(ngModel)]="selectedSortiments" optionLabel="attributeName">
            </p-multiSelect>
          </div>
        </div>

        <div class="grid">
          <hr>
            <div class="col-2">
              <p-checkbox id="withUpload" [(ngModel)]="includeUpload" binary="true"
              [disabled]="recipients.length > 0"></p-checkbox>
              <label class="ml-2"  for="withUpload" >Liste</label>
            </div>
            @if (includeUpload) {
              <div class="col-1">
                Art:
              </div>
            }
            @if (includeUpload) {
              <div class="col-5">
                <p-select id="validationSelection" [options]="validationProfiles$ | async" placeholder="Listenart angeben"
                  [(ngModel)]="selectedValidation" [disabled]="recipients.length > 0">
                </p-select>
              </div>
            }
            @if (includeUpload) {
              <div class="col-3" style="margin-left: 20px;">
                <p-checkbox id="loadSortimentArtikel" [(ngModel)]="loadSortimentArtikel" binary="true"  [disabled]="recipients.length > 0"></p-checkbox>
                <label class="ml-2"  for="loadSortimentArtikel" >Artikel aus Sortimentieren laden</label>
              </div>
            }
          </div>
          <div class="grid">
            <hr>
              @if (includeUpload) {
                <div class="col-2">
                  Minimum:
                </div>
              }
              @if (includeUpload) {
                <div class="col-2">
                  <p-spinner [(ngModel)]="minListRows" [disabled]="recipients.length > 0"></p-spinner>
                </div>
              }
              @if (includeUpload) {
                <div class="col-2" style="margin-left: 25px;">
                  Maximum:
                </div>
              }
              @if (includeUpload) {
                <div class="col-2">
                  <p-spinner [(ngModel)]="maxListRows" [disabled]="recipients.length > 0"></p-spinner>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="col-6" style="border-left: solid; border-color: lightgray; border-width: 0.05em; padding-left: 10px;">
        <div class="grid">
          <div class="col-11">
            <div class="ui-grid-col-2">Aufgabentext</div>
            <!-- <div class="ui-grid-col-10" style="margin-left: 15 px;">
            <input id="aufgabeInput" type="text" size="200" style="width: 100%;" [(ngModel)]="taskname" pInputText />
          </div> -->
          <div class="col-10" style="margin-left: 15px;">
            <p-select [options]="taskInfoTexts" [(ngModel)]="taskname" placeholder="Wählen Sie einen Aufgabentext" editable="true" [disabled]="recipients.length > 0"></p-select>
          </div>
        </div>
        <div class="col-11" style="margin-top: 10px;">
          <div class="col-2">Information</div>
          <div class="col-10">
            <textarea id="desc" maxlength="3000" rows="4" cols="30" pTextarea [(ngModel)]="description" [disabled]="recipients.length > 0"></textarea>
          </div>
        </div>
        <div class="col-11">
          <hr>
            <div class="col-2">Laufzeit</div>
            <div class="col-4">
              <p-datepicker [(ngModel)]="taskActivityRange" [firstDayOfWeek]="1" dateFormat="dd.mm.yy" selectionMode="range"
              showButtonBar="true" [showIcon]="true" [disabled]="recipients.length > 0" (onSelect)="changeValidRange()" (onInput)="changeValidRange()"></p-datepicker>
            </div>
            <div class="col-2" style="padding-left: 35px;">Bearbeitung</div>
            <div class="col-4">
              <p-datepicker [(ngModel)]="taskValidRange" [firstDayOfWeek]="1" dateFormat="dd.mm.yy" selectionMode="range"
              showButtonBar="true" [showIcon]="true" [disabled]="recipients.length > 0"></p-datepicker>
            </div>
          </div>
          <div class="col-11">
            <hr>
              <div class="col-3" style="padding-left: 10px;">
                <p-checkbox id="withInvite" [(ngModel)]="sendInvite" binary="true"  [disabled]="recipients.length > 0"></p-checkbox>
                <label class="ml-2"  for="withInvite" >Einladen</label>
                @if (sendInvite) {
                  <div  style="margin-top: 5px;">
                    <p-datepicker [(ngModel)]="invitationDate" [firstDayOfWeek]="1" dateFormat="dd.mm.yy"
                    showButtonBar="true" [showIcon]="true" [disabled]="!sendInvite || recipients.length > 0"></p-datepicker>
                  </div>
                }
              </div>
              <div class="col-3" style="padding-left: 10px;">
                <p-checkbox [(ngModel)]="sendReminderOne" binary="true" id="Erinnerung1" [disabled]="recipients.length > 0"></p-checkbox>
                <label class="ml-2"  for="Erinnerung1" >Erinnerung 1</label>
                @if (sendReminderOne) {
                  <div style="margin-top: 5px;">
                    <p-datepicker [(ngModel)]="remindDateOne" [firstDayOfWeek]="1" dateFormat="dd.mm.yy"
                    showButtonBar="true" [showIcon]="true" [disabled]="recipients.length > 0"></p-datepicker>
                  </div>
                }
              </div>
              <div class="col-3" style="padding-left: 10px;">
                <p-checkbox [(ngModel)]="sendReminderTwo" binary="true" id="Erinnerung2" [disabled]="recipients.length > 0"></p-checkbox>
                <label class="ml-2"  for="Erinnerung2" >Erinnerung 2</label>
                @if (sendReminderTwo) {
                  <div style="margin-top: 5px;">
                    <p-datepicker [(ngModel)]="remindDateTwo" [firstDayOfWeek]="1" dateFormat="dd.mm.yy"
                    showButtonBar="true" [showIcon]="true" [disabled]="recipients.length > 0"></p-datepicker>
                  </div>
                }
              </div>
              <div class="col-3" style="padding-left: 10px;">
                <p-checkbox [(ngModel)]="sendReminderThree" binary="true" id="Erinnerung3" [disabled]="recipients.length > 0"></p-checkbox>
                <label class="ml-2"  for="Erinnerung3" >Erinnerung 3</label>
                @if (sendReminderThree) {
                  <div style="margin-top: 5px;">
                    <p-datepicker [(ngModel)]="remindDateThree" [firstDayOfWeek]="1" dateFormat="dd.mm.yy"
                    showButtonBar="true" [showIcon]="true" [disabled]="recipients.length > 0"></p-datepicker>
                  </div>
                }
              </div>
            </div>
            <div class="col-11">
              <hr>
                <div class="col-2">Anhang</div>
                <div class="col-8">
                  <p-fileUpload #fubauto name="uploadFiles[]" invalidFileTypeMessageSummary="{0} Datei nicht erlaubt" chooseLabel="Neu..."  multiple="multiple" fileLimit="5" invalidFileLimitMessageSummary="Maximal 5 Dateien erlaubt"
                    accept=".xlsx,.jpg,.png,.pdf" maxFileSize="1000000" [disabled]="recipients.length > 0" customUpload="true" (uploadHandler)="uploadFiles($event)" mode="advanced"
                    previewWidth="30" auto="true">
                  </p-fileUpload>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr>


          <p-footer>
            <hr>
              <div class="ui-grid ui-grid-responsive">
                <div class="ui-grid-col-1">
                  @if (editMode && taskname && taskValidRange && recipients) {
                    <button pButton
                    label="Speichern" class="p-button-success" (click)="createTask()" [disabled]="!(hideUserEdit=='hidden') || (isTaskSaving$ | async)"></button>
                  }
                  @if (editMode && (!taskname || !taskValidRange || !taskActivityRange || !recipients)) {
                    <button pButton
                      label="Speichern" class="p-button-secondary" [disabled]="true"
                      pTooltip="Geben sie Aufgabenname und Start/Ende ein. Wählen Sie min. einen Empfänger."
                    tooltipPosition="top"></button>
                  }
                </div>
                @if (isTaskSaving$ | async) {
                  <div class="ui-grid-col-2">
                    <p-progressSpinner [style]="{width: '25px', height:'25px'}"></p-progressSpinner>
                  </div>
                }
                <div class="ui-grid-col-6">
                  <button pButton  label="Beenden" class="p-button-info" (click)="close()" [disabled]="!(hideUserEdit=='hidden') || (isTaskSaving$ | async)"></button>

                </div>

              </div>
            </p-footer>
